module.exports = __webpack_public_path__ + "img/prod.8ddc35c8.jpg";